import { Modal } from '@winnin/winnin_ui.components.modal'
import { TabsToggle } from '@winnin/winnin_ui.components.tabs-toggle'

import { SMALL_MODAL } from 'consts/modalStyles'
import { GroupNichesForm } from 'modules/niche/group-niches-form'
import { RenameNichesForm } from 'modules/niche/rename-niches-form'

import type { TEditNicheModalView } from './edit-niche-modal.types'
import './edit-niche-modal.styles.scss'

export const EditNicheModalView = ({ handleClose, isOpen, activeTab, handleToggleTab, tabs }: TEditNicheModalView) => {
  return (
    <Modal style={SMALL_MODAL} isOpen={isOpen} onRequestClose={handleClose}>
      <div className="EditNicheModal">
        <TabsToggle onClick={handleToggleTab} tabs={tabs} activeTab={activeTab} />
        {activeTab.value === 'rename' && <RenameNichesForm handleClose={handleClose} />}
        {activeTab.value === 'group' && <GroupNichesForm handleClose={handleClose} />}
      </div>
    </Modal>
  )
}
